import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
export const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  idx1: number
): ModuleFields[] => {
  return languages.flatMap((lang) => [
    {
      fieldName: `Title (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].title`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].title`,
      formType: "input",
      label: `Title (${lang.code})`,
      placeholder: `Enter Title ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Title ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Markup (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].markup`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].markup`,
      formType: "richText",
      label: `Markup (${lang.code})`,
      placeholder: `Enter Markup ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Markup ${lang.code} is required` } : undefined,
    },
  ]);
};
export const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];
let url = `/api/page-content/all-fields?pageName=about-us/subsidiaries`;
export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;
const fetchSubsidiariesData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const subsidiariesData = res.data;
    const fields1 =
      subsidiariesData?.[0]?.field_content_english?.data?.items?.map((item: any, index: number) =>
        generateFields("data", languages, index)
      ) || [];
    return {
      subsidiaries: fields1 as ModuleFields[],
    };
  } catch (error) {
    return null;
  }
};
export const getDynamicSubsidiariesDrillDownData = async () => {
  if (!getData) {
    getData = await fetchSubsidiariesData();
  }
  return getData;
};
